<template>
    <section class="rose" id="myRoseEcharts">
    </section>
</template>

<style lang="scss" scoped="scoped">
    .rose {
        width: 100%;
        height: 100%;
        display: inline-flex;
    }
</style>

<script>
    export default {
        components: {

        },
        data () {
            return {
                myChart: {}
            }
        },
        props: ["roseInfo"],
        computed: {
            getOption () {
                let opt = {
                    tooltip: {
                        show: true,
	                    confine: true,
                        backgroundColor: 'rgba(255, 255, 255, .92)',
                        textStyle: {
                            color: '#142C3D'
                        },
                        extraCssText: 'box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);'
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        top: '2%',
                        bottom: '2%',
                        containLabel: true
                    },
                    series: [
                        {
                            name: '销售额',
                            type: 'pie',
                            radius: [25, 130],
                            center: ['50%', '50%'],
                            roseType: 'radius',
                            label: {
                                normal: {
                                    show: false
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            color: this.color,
                            data: this.roseInfo
                        }
                    ]
                }
                return opt;
            },

            color () {
                let color = [];
                this.roseInfo.forEach((item) => {
                    color.push(item.color);
                })
                return color;
            }
        },
	    watch: {
		    roseInfo: {
			    handler: function () {
				    this.changeEcharts();
			    },
			    deep: true
		    }
	    },
        methods: {
            setEcharts () {
                let dom = document.getElementById('myRoseEcharts');
                this.myChart = echarts.init(dom);
                this.myChart.setOption(this.getOption);
            },
            changeEcharts () {
                this.myChart.setOption(this.getOption);
            }
        },
        mounted () {
            this.setEcharts();
        }
    }
</script>



// WEBPACK FOOTER //
// Rose.vue?c57d6fa8